import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";

export const renderFavToggle = ({
    schemaItem,
    item,
    columnKey,
}: TableCellProps) => (
    <td class={schemaItem.className} data-testid={columnKey}>
        <ux-toggle-button
            sync-id={`ux-iws-${item.number}`}
            icon-on="fav-filled"
            icon-off="fav"
            toggle-url={item[columnKey].toggleUrl}
            key={item[columnKey].toggleUrl}
            on={item[columnKey].active}
        />
    </td>
);
